export default __webpack_public_path__ + "static/media/chevron-right.d45fd2f4.svg";